import NBType, { InferType } from '@netbase/nb-type'
import GeoFencingLonLatSchema from './GeoFencingLonLatSchema'
import GeometryType from '../enums/GeometryType'

/**
 * @typedef {object} GeoFencingLonLatSchema
 * @property {number} lat
 * @property {number} lon
 */
const GeoFencingSchema = NBType.object().shape('GeoFencingSchema', {
  /* @prop */
  label: NBType.string().nullable(),
  /* @prop */
  lonLats: NBType.array().of(GeoFencingLonLatSchema).nullable(),
  /* @prop */
  radius: NBType.number().nullable(),
  /* @prop */
  type: NBType.enum(GeometryType).nullable(),
  /* @prop */
  zoom: NBType.number().nullable()
  /* END */
})
export default GeoFencingSchema
export type GeoFencing = InferType<typeof GeoFencingSchema>
// RESERVE BELOW
